// Providers
export { WalletProvider } from "./WalletProvider";
export { WalletModalProvider } from "./WalletModal";
export type { WalletBalanceKey } from "./types";
export type {
    SolomonE2EChainOverride,
    SolomonE2EOverrides,
    SolomonE2ESignerOverride,
    SolomonE2EWalletOverride
} from "./e2e";

// Custom hooks with solomon-labs types
export { useWallet } from "./hooks/useWallet";
export type { WalletState } from "./types";
export {
    useTokenBalances,
    useTokenBalancesActions,
    useTokenBalancesController,
    useTokenBalancesData
} from "./hooks/useTokenBalances";
export {
    fetchUsdvBalanceForAddress,
    USDV_BALANCE_GC_TIME_MS,
    USDV_BALANCE_STALE_TIME_MS,
    usdvBalanceQueryKey,
    useUsdvBalanceForAddress
} from "./hooks/useUsdvBalanceForAddress";
export type { UseUsdvBalanceResult } from "./hooks/useUsdvBalanceForAddress";
export type { ReconcileBalancesOptions } from "./utils/balanceReconciliation";
export type {
    UseTokenBalancesActionsResult,
    UseTokenBalancesControllerResult,
    UseTokenBalancesDataResult
} from "./hooks/useTokenBalances";

// Modal hooks
export { useWalletModal, useUnifiedWalletContext } from "./WalletModal";
export type { ConnectingStep } from "./WalletConnectingModal";

// UI — state-driven wallet connect button (shared across apps)
export { WalletConnectButton } from "./WalletConnectButton";
export type { WalletConnectState } from "./WalletConnectButton";

// Re-export ConnectorKit hooks for advanced use cases
export { useConnector } from "@solana/connector/react";
// E2E-aware wrapper: identical shape to ConnectorKit's hook, but resolves to
// the in-memory smoke signer when `window.__SOLOMON_E2E__.signer` is set.
export { useTransactionSigner } from "./hooks/e2e";

export { useWalletMessageSigner } from "./hooks/useWalletMessageSigner";
